import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../api/api-response';
import { UsuarioBusca } from './usuarios.model';

@Injectable({ providedIn: 'root' })
export class UsuariosService {
  private readonly http = inject(HttpClient);
  private readonly url = `${environment.apiUrl}/Usuarios`;

  buscar(termo: string, take = 20): Observable<ApiResponse<UsuarioBusca[]>> {
    const params = new HttpParams().set('termo', termo).set('take', take);
    return this.http.get<ApiResponse<UsuarioBusca[]>>(`${this.url}/buscar`, { params });
  }

  admins(): Observable<ApiResponse<UsuarioBusca[]>> {
    return this.http.get<ApiResponse<UsuarioBusca[]>>(`${this.url}/admins`);
  }

  conceder(nmUsuario: string): Observable<ApiResponse<boolean>> {
    return this.http.post<ApiResponse<boolean>>(`${this.url}/admin`, { nmUsuario });
  }

  revogar(nmUsuario: string): Observable<ApiResponse<boolean>> {
    return this.http.delete<ApiResponse<boolean>>(`${this.url}/admin/${encodeURIComponent(nmUsuario)}`);
  }
}
